import { z } from 'zod'

export enum FeedbackRating {
  Up = 'up',
  Down = 'down'
}

export enum FeedbackSubjectKind {
  AuroraMessage = 'aurora_message',
  SproutSummary = 'sprout_summary'
}

export const feedbackSubjectSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal(FeedbackSubjectKind.AuroraMessage), messageId: z.string() }),
  z.object({ kind: z.literal(FeedbackSubjectKind.SproutSummary), streamId: z.string() })
])

export type FeedbackSubject = z.infer<typeof feedbackSubjectSchema>

export enum AuroraMessageFeedbackCategory {
  Inaccurate = 'inaccurate',
  Unhelpful = 'unhelpful',
  IgnoredRequest = 'ignored_request',
  Other = 'other'
}

export enum FeedbackStep {
  Open = 'open',
  Category = 'category',
  Details = 'details',
  Skip = 'skip'
}

export const feedbackStepSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal(FeedbackStep.Open),
    subject: feedbackSubjectSchema,
    rating: z.enum(FeedbackRating)
  }),
  z.object({ kind: z.literal(FeedbackStep.Category), category: z.string() }),
  z.object({ kind: z.literal(FeedbackStep.Details), text: z.string().trim().min(1) }),
  z.object({ kind: z.literal(FeedbackStep.Skip) })
])

export type FeedbackStepInput = z.infer<typeof feedbackStepSchema>
